<template>
  <nav class="nav-desktop" role="navigation">

    <!-- nav__primary -->
    <ul class="nav nav--inline nav--primary">
      <li class="nav__item"><a :href="$utils.getWpPath('about')" class="nav__link">เกี่ยวกับ กสศ.</a></li>
      <li class="nav__item"><a :href="$utils.getWpPath('our-work')" class="nav__link">งานของเรา</a></li>
      <li class="nav__item"><a :href="$utils.getWpPath('fund')" class="nav__link">ทุน</a></li>
      <li class="nav__item"><a :href="$utils.getWpPath('knowledge')" class="nav__link">คลังสมอง</a></li>
      <li class="nav__item"><a :href="$utils.getWpPath('contact')" class="nav__link">ติดต่อ</a></li>
    </ul>

    <!-- nav__secondary -->




  </nav>
</template>

<script>
  export default {
    name: 'NavMenuTop',
    data () {
      return {
        dropdownVisible: false,
        images: {
          close: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjEyLjk4MiAyMTIuOTgyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyMTIuOTgyIDIxMi45ODI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiPgo8ZyBpZD0iQ2xvc2UiPgoJPHBhdGggc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkOyIgZD0iTTEzMS44MDQsMTA2LjQ5MWw3NS45MzYtNzUuOTM2YzYuOTktNi45OSw2Ljk5LTE4LjMyMywwLTI1LjMxMiAgIGMtNi45OS02Ljk5LTE4LjMyMi02Ljk5LTI1LjMxMiwwbC03NS45MzcsNzUuOTM3TDMwLjU1NCw1LjI0MmMtNi45OS02Ljk5LTE4LjMyMi02Ljk5LTI1LjMxMiwwYy02Ljk4OSw2Ljk5LTYuOTg5LDE4LjMyMywwLDI1LjMxMiAgIGw3NS45MzcsNzUuOTM2TDUuMjQyLDE4Mi40MjdjLTYuOTg5LDYuOTktNi45ODksMTguMzIzLDAsMjUuMzEyYzYuOTksNi45OSwxOC4zMjIsNi45OSwyNS4zMTIsMGw3NS45MzctNzUuOTM3bDc1LjkzNyw3NS45MzcgICBjNi45ODksNi45OSwxOC4zMjIsNi45OSwyNS4zMTIsMGM2Ljk5LTYuOTksNi45OS0xOC4zMjIsMC0yNS4zMTJMMTMxLjgwNCwxMDYuNDkxeiIgZmlsbD0iI0ZGRkZGRiIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='
        }
      }
    },
    created () {
      document.getElementsByTagName('body')[0].addEventListener('click', this.clickListener, false)
    },
    unmounted () {
      document.getElementsByTagName('body')[0].removeEventListener('click', this.clickListener, false)
    },
    computed: {
      isLoggedIn () {
        return this.$store.state.token
      },
      name () {
        const user = this.$store.state.user
        if (user.firstName || user.lastName) {
          return `${this.$store.state.user.firstName} ${this.$store.state.user.lastName}`
        } else if (user.email && !user.email.match(/tel.(\d+)@tcfe.or.th/g)) {
          return user.email
        } else if (user.telNo) {
          return user.telNo
        } else {
          return '<Unknown>'
        }
      }
    },
    methods: {
      clickListener (ev) {
        if (this.$refs.dropdown && !this.$refs.dropdown.contains(ev.target)) {
          this.dropdownVisible = false
        }
      },
      hideMenu () {
        this.$emit('hideMenu')
      },
      toggleDropdown () {
        this.dropdownVisible = !this.dropdownVisible
      },
      hideDropdown () {
        this.dropdownVisible = false
      }
    },
    watch: {
      '$route': function () {
        this.hideDropdown()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// NavMenuTop.vue?08aa1042